import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { OlaApi } from "@jti/rest-api";
import { CircleLoader } from "../CircleLoader";
import "./DoubleOptInRedirect.scss";
export const DoubleOptInRedirect = ({ successPageRedirectUrl, errorPageRedirectUrl }) => {
    useEffect(() => {
        const olaApi = OlaApi.init();
        const query = new URLSearchParams(window.location.search);
        olaApi
            .validateHash(query.get("hash") || "")
            .then((res) => {
            if (res.token) {
                window.location.href = `${successPageRedirectUrl}#/new-password-set/${res.token}`;
            }
            else {
                window.location.href = errorPageRedirectUrl;
            }
        })
            .catch(() => {
            window.location.href = errorPageRedirectUrl;
        });
    });
    return (_jsx(_Fragment, { children: createPortal(_jsx("div", { className: "double-opt-in__container", children: _jsx(CircleLoader, { dataTestId: "doubleOptInLoader" }) }), document.body) }));
};
//# sourceMappingURL=DoubleOptInRedirect.js.map